// this should be the same as apps/bazaar/api/v2/constants.py#PAGE_SIZE

export const ITEMS_PER_PAGE = 40;

export const RECENT_REVIEW_DAYS = 90 * 24 * 60 * 60 * 1000; // 90 days
export const REVIEWS_PER_PAGE = 50;
export const TRANSACTIONS_PER_PAGE = 30;

export const IS_SLOW_SCROLL_ENABLED = true;

export enum Viewer {
    ADMIN,
    SELLER,
    BUYER,
}
